/* HIT posts API ENDPOINT */

import Api from '@/services/Api'

export default {
  getFilterTags () {
    return Api().get('menu/filtertags')
  },
  getFilterTag (filtertag) {
    return Api().get('menu/edit/filtertag/' + filtertag)
  },
  deleteFilterTag (filtertag) {
    return Api().delete('menu/edit/filtertags/:filtertag', { data: filtertag })
  },
  addFilterTag (filtertag) {
    return Api().post('menu/edit/filtertags/:filtertag', filtertag)
  },
  updateFilterTag (filtertag) {
    return Api().put('menu/edit/filtertags/:filtertag', filtertag)
  },
  getEditFilterTagItems (filtertag) {
    return Api().get('menu/edit/filtertags/' + filtertag)
  }
}



// WEBPACK FOOTER //
// ./src/services/FilterTagsService.js